import React from "react";

import NewInput from "../../../../../shared/forms/NewInput";
import NewHeadline from "../../../../../shared/NewHeadline";
import DeliveryDetails from "../store";

const Comment = () => {
    const [orderComment, setOrderComment] = DeliveryDetails((state) => [
        state.orderComment,
        state.setOrderComment,
    ]);

    /**
     * When the order comment changes.
     *
     * @param {*} event
     */
    const onChangeComment = (event) => {
        setOrderComment(event.target.value);
    };

    return (
        <React.Fragment>
            <NewHeadline>Anmerkung</NewHeadline>

            <NewInput
                type="textarea"
                placeholder="Anmerkung zur Lieferung. z.B. Sackgasse, bitte rückwärts reinfahren"
                value={orderComment}
                onChange={onChangeComment}
                withField
            />
        </React.Fragment>
    );
};

export default Comment;
